export default {
	FULL: 'FULL',
	MINI: 'MINI',
	NONE: 'NONE',
};
